import { Base } from "./../../framework/base";
import { IdTitle } from "./../common/idTitle";
import { TaskDataRowDataType, TaskDataRowTotalType } from "./../enums";
import { IdTitleNode } from "../common/idTitleNode";
export var modifyUserNameField = "ModifyUserName";
export var modifyDateField = "ModifyDate";
var TaskTypeCol = /** @class */ (function () {
    function TaskTypeCol(obj) {
        this.field = obj && obj.field || "";
        this.title = obj && obj.title || "";
        this.dataType = obj && obj.dataType || TaskDataRowDataType.String;
        this.decimals = obj && obj.decimals || 0;
        this.defaultStr = obj && obj.defaultStr || "";
        this.defaultNbr = null;
        if (!Base.isNullOrUndefined(obj) && !Base.isNullOrUndefined(obj.defaultNbr)) {
            this.defaultNbr = obj.defaultNbr;
        }
        this.defaultExpression = obj && obj.defaultExpression || "";
        this.unitTitle = obj && obj.unitTitle || "";
        this.readOnly = obj && obj.readOnly || false;
        this.readOnlyExpression = obj && obj.readOnlyExpression || "";
        this.required = obj && obj.required || false;
        this.useInFilter = obj && obj.useInFilter || false;
        this.minimum = null;
        if (!Base.isNullOrUndefined(obj) && !Base.isNullOrUndefined(obj.minimum)) {
            this.minimum = obj.minimum;
        }
        this.maximum = null;
        if (!Base.isNullOrUndefined(obj) && !Base.isNullOrUndefined(obj.maximum)) {
            this.maximum = obj.maximum;
        }
        this.maxLength = obj && obj.maxLength || null;
        this.options = [];
        if (obj && obj.options) {
            this.options = obj.options;
        }
        this.idOptions = Base.getTypedArray(obj ? obj.idOptions : null, IdTitle);
        this.idNodeOptions = Base.getTypedArray(obj ? obj.idNodeOptions : null, IdTitleNode);
        this.class = obj && obj.class || "";
        this.expression = obj && obj.expression || "";
        this.expressionFormat = obj && obj.expressionFormat || "";
        this.expressionIndex = obj && obj.expressionIndex || 0;
        this.defaultSortField = obj && obj.defaultSortField || false;
        this.defaultSortOrderAsc = obj && obj.defaultSortOrderAsc || false;
        this.placeholder = obj && obj.placeholder || "";
        this.lineTotalType = obj && obj.lineTotalType || TaskDataRowTotalType.None;
        this.lineTotalExpression = obj && obj.lineTotalExpression || "";
        this.selectOptionsSubSectionValuesByTitle = obj && obj.selectOptionsSubSectionValuesByTitle || false;
    }
    TaskTypeCol.sortExpressionTaskTypeCols = function (items) {
        if (Base.isNullOrUndefined(items) || items.length < 2)
            return;
        items.sort(function (a, b) { return (Base.isNullOrUndefined(a) || Base.isNullOrUndefined(b)) ? 0 : (Base.numCompare(a.expressionIndex, b.expressionIndex)); });
    };
    TaskTypeCol.isSaveDataType = function (dataType) {
        return dataType !== TaskDataRowDataType.Label && dataType !== TaskDataRowDataType.LineBreak;
    };
    TaskTypeCol.isSavedTaskDataField = function (field) {
        var notSavedFields = [modifyUserNameField, modifyDateField];
        return notSavedFields.findIndex(function (i) { return i.equalIgnoreCase(field); }) < 0;
    };
    TaskTypeCol.colCanBeUsedInFilter = function (taskTypeCol) {
        if (!taskTypeCol)
            return false;
        return taskTypeCol.dataType === TaskDataRowDataType.Date ||
            taskTypeCol.dataType === TaskDataRowDataType.Time ||
            taskTypeCol.dataType === TaskDataRowDataType.String && taskTypeCol.idNodeOptions.length < 1 ||
            taskTypeCol.dataType === TaskDataRowDataType.TimeSpan ||
            taskTypeCol.dataType === TaskDataRowDataType.Integer ||
            taskTypeCol.dataType === TaskDataRowDataType.Number ||
            taskTypeCol.dataType === TaskDataRowDataType.Boolean;
    };
    TaskTypeCol.prototype.isSaveDataType = function () {
        return TaskTypeCol.isSaveDataType(this.dataType);
    };
    TaskTypeCol.prototype.isSavedTaskDataField = function () {
        return TaskTypeCol.isSavedTaskDataField(this.field);
    };
    TaskTypeCol.prototype.canBeFiltered = function () {
        return TaskTypeCol.colCanBeUsedInFilter(this);
    };
    ;
    TaskTypeCol.isCalculatedField = function (item) {
        if (!item)
            return false;
        return (item.dataType === TaskDataRowDataType.Number || item.dataType === TaskDataRowDataType.Integer) && !!item.expression;
    };
    TaskTypeCol.validateInputOfRequiredTaskTypeCols = function (typeCols, rowCols, successCallback, errorCallback) {
        var _loop_1 = function (i) {
            var typeCol = typeCols[i];
            if (!typeCol.required)
                return "continue";
            var rowCol = rowCols.find(function (j) { return j.field === typeCol.field; });
            if (!rowCol || !rowCol.valueStr) {
                errorCallback(typeCol);
                return { value: void 0 };
            }
        };
        for (var i = 0; i < typeCols.length; i++) {
            var state_1 = _loop_1(i);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        if (!successCallback)
            return;
        successCallback();
    };
    TaskTypeCol.getTaskTypeColTitle = function (typeCols, field) {
        if (!typeCols || !field)
            return "";
        var typeCol = typeCols.find(function (i) { return i.field === field; });
        if (!typeCol)
            return field;
        return typeCol.title;
    };
    return TaskTypeCol;
}());
export { TaskTypeCol };
